import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    sessionToken: null,
    user: null, // 用户信息
    isRead: false, // 是否引导标识
    toggleFooter: true, // 底部导航栏是否显示
    adMapImage: null, // 首页广告图
    shoppingSum: null, // 购物车计数量
    searchWords: [], // 搜索数组
    addressId: null, // 当前选择的收货地址id
    statusBarHeight: 20, // 状态栏高度
    selectedProductsData: [], // 选定要结算的购物车数据
    orderMiddleValue: null // 用于订单列表操作渲染页面的改变
  },
  mutations,
  actions
})
export default store
